import { observable, computed } from "mobx";

export default class RootStore {
    constructor() {}
}
